import { User } from "./user.model";

export const users: User[] = [
  {
    UserID: "0cc2f6ad-835f-4fc0-8b2a-a009cf07094d",
    UserName: "admin",
    Email: "vkoutra@bluedotebusiness.com",
    EmailConfirmed: 1,
    isActive: 1,
    Roles: [
        "Admin"
    ]
  },
  {
      UserID: "0f582566-2e58-4bae-aee7-f1516431244d",
      UserName: "SecretaryEopyy",
      Email: "nkoutsourakis@bluedotebusiness.com",
      EmailConfirmed: 1,
      isActive: 1,
      Roles: [
          "SecretaryEopyy"
      ]
  }
];
